/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { FaAnglesRight, FaAnglesLeft } from "react-icons/fa6";
import { useLocation } from "react-router-dom";

const HelpTour = ({ start, setStartTour, onStopTour }) => {
  const location = useLocation();
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    // Generate steps based on location.pathname dynamically
    const path = location.pathname;
    let dynamicSteps = [
      {
        target: '.tour-logo',
        title: "Application Logo",
        content: "Click here to return to the dashboard.",
        placement: 'bottom',
        disableBeacon: true,
      }
    ];

    if (path === '/dashboard') {
      dynamicSteps.push({
        target: '.dashboard-module',
        title: "Dashboard Overview",
        content: "View all available modules along with their respective metrics and counts.",
        placement: 'bottom-start',
        disableBeacon: true,
      });
    } else if (path === '/usertracking') {
      dynamicSteps.push(
        {
          target: '.dashboard-module',
          title: "User Tracking Tool",
          content: "This tool logs visitor session logs, click events, and site demographics in real-time.",
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.tracking-tabs',
          title: "Dashboard Modules",
          content: "Use these tabs to switch between Overview, Live Traffic, Audience demographics, Sessions log, Click Analytics, Journey Simulator, CDN Tag Snippet, DB config, and Delete manager.",
          placement: 'bottom',
          disableBeacon: true,
        }
      );
    } else {
      // General CMS Page Tour
      const hasAddBtn = document.querySelector('.add-button');
      const hasSearch = document.querySelector('.search-button');
      const hasExport = document.querySelector('.export-data');
      const hasTable = document.querySelector('.table-data') || document.querySelector('.table');
      const hasPagination = document.querySelector('.pagination');

      if (hasAddBtn) {
        dynamicSteps.push({
          target: '.add-button',
          title: "Add New Record",
          content: "Click here to create and add a new record to the current module.",
          placement: 'right',
          disableBeacon: true,
        });
      }
      if (hasSearch) {
        dynamicSteps.push({
          target: '.search-button',
          title: "Search Records",
          content: "Use this search field or click to find specific records quickly.",
          placement: 'left',
          disableBeacon: true,
        });
      }
      if (hasExport) {
        dynamicSteps.push({
          target: '.export-data',
          title: "Export Data",
          content: "Use this option to export the currently filtered data as a CSV file.",
          placement: 'left',
          disableBeacon: true,
        });
      }
      if (hasTable) {
        dynamicSteps.push({
          target: document.querySelector('.table-data') ? '.table-data' : '.table',
          title: "Data Table",
          content: "All records for this module are displayed in this table. You can use the inline buttons to View, Edit, or Delete items.",
          placement: 'center',
          disableBeacon: true,
        });
      }
      if (hasPagination) {
        dynamicSteps.push({
          target: '.pagination',
          title: "Pagination Controls",
          content: "Navigate through pages to view additional records.",
          placement: 'bottom',
          disableBeacon: true,
        });
      }
    }

    dynamicSteps.push({
      target: ".logout",
      title: "Logout Controls",
      content: "Click here to log out of the admin panel safely.",
      placement: "bottom",
      disableBeacon: true,
    });

    setSteps(dynamicSteps);
  }, [location.pathname]);

  const handleJoyrideCallback = useCallback(
    (data) => {
      const { status, type } = data;

      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status) || type === "tour:end") {
        setStartTour(false);
        if (onStopTour) onStopTour();
      }

      if (type === "step:before" && data.step?.target) {
        const element = document.querySelector(data.step.target);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center"
          });
        }
      }
    },
    [setStartTour, onStopTour]
  );

  const tooltipStyle = {
    options: {
      zIndex: 10000,
      arrowColor: '#fff',
      backgroundColor: '#fff',
      primaryColor: '#526cfe',
      width: "320px",
    },
    buttonSkip: {
      backgroundColor: "#ef4444",
      padding: "8px 12px",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      fontSize: "12px",
      fontWeight: "600"
    },
    buttonBack: {
      backgroundColor: "#fff",
      border: "1px solid #d1d5db",
      color: "#4b5563",
      padding: "8px 12px",
      borderRadius: "6px",
      fontSize: "12px",
      fontWeight: "600",
      marginRight: "8px"
    },
    buttonNext: {
      backgroundColor: "#526cfe",
      border: "none",
      color: "#fff",
      padding: "8px 12px",
      borderRadius: "6px",
      fontSize: "12px",
      fontWeight: "600"
    }
  };

  if (steps.length === 0) return null;

  return (
    <Joyride
      steps={steps}
      run={start}
      continuous
      showSkipButton={true}
      hideCloseButton
      disableCloseOnEsc
      disableOverlayClose
      scrollToFirstStep
      styles={tooltipStyle}
      callback={handleJoyrideCallback}
      locale={{
        back: <FaAnglesLeft />,
        next: <FaAnglesRight />,
        last: "Finish",
        skip: "Skip Tour"
      }}
    />
  );
};

export default HelpTour;
